<template>
  <div class="contents" >
    <nyTit1 pathUrl="/xianqing1" />
    <!-- 下部分内容开始 -->
    <div class="xia_content">
      <!-- 第1块开始 -->
      <div class="first1">
        <!-- 第1块上部分 -->
        <div class="first1_top">
          <!-- 标题区域 -->
          <div class="title"><span class="txt1">{{state.font1.name}}</span><span class="txt2"></span></div>
          <!-- 标题区域 -->
          <!-- 第一块内容区域 -->
          <div class="content_bt_qy">
            <div class="first1_top_down_jian_jie">{{state.font1.info}}</div>
            <div class="leftImg">
              <img  class="first1_top_down_img"  src="../assets/img/shancaixianqing/xq1/left2.jpg"  />
              <img  class="first1_top_down_img"  src="../assets/img/shancaixianqing/xq1/left1.jpg"  />

            </div>

            
          </div>
          <!-- 第一块内容区域 -->
        </div>
        <!-- 第1块上部分 -->
      </div>
      <!-- 第1块 结束-->
      <!-- 第2块开始 -->

      <!--  第2块 结束-->
      <!-- 第3块 开始-->
      <div class="first3">

        <div class="first3Box">
          <div class="videoBox">
          <div class="shiptz">
            <vue3VideoPlay ref="videoPlayer"  loop  :poster="state.options.poster" color="#ff0000"  width="100%"  height="100%"  title="冰河世纪"  :src="state.options.src"  :type="state.options.type"  :autoPlay="false"  @play="onPlay"/>
            <!-- <button @click="muteVideo"  class="jingyin">静音</button> -->
          </div>
          </div>
        </div>
      </div>
      
      <!-- 第3块结束-->
      <!-- 第4块 开始-->
      <div class="first4">
        <div class="title"><span class="txt1">上蔡县电商基地</span><span class="txt2"></span></div>
        <div class="first4_box2">
          <div class="fontBox">上蔡县电商基地利用原建业大食堂改造建设，建筑面积3.5万平方米，主要包括农特产品电商交易中心、创新创业中心、中小企业孵化中心、农产品质量检测中心、冷链仓储物流中心和电商培训学校。</div>
          <div class="rightList">
            <div class="rightListItem" v-for="(item,index) in state.right_img" :key="index">
              <img :src="item.img" />
              <h5>{{item.name}}</h5>
            </div>
          </div>
        </div>
      </div>
      <!--  第4块结束 -->
      <!-- 第5块开始 -->

      <!-- 第5块结束 -->
    </div>
    <!-- 下部分内容结束 -->
  </div>
<!--  <footer1 />-->
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
// import waterimg from "@/assets/img/xaiofei/fk.png"

import nyTit1 from '../components/nyTit1.vue'
import countTo from "@/components/vue-count-to/src/vue-countTo.vue";
import rightPie from '../components/shangcaixq/right_pie'
import bigFont from '../components/bigFont.vue'
import footer1 from "../components/footer.vue";
  name: "Home";
  const videoPlayer = ref(null);
  const { proxy } = getCurrentInstance();
  // const timer = ref(null);
  const router = useRouter();
  const state = reactive({
    url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
    currentTime: "",
    font1:{
      name:"上蔡县国家农村产业融合发展示范园",
      info: "上蔡县国家农村产业融合发展示范园是在原五七干校和知青农场原址基础上规划建设的，总占地面积2745亩，2020年9月被国家发改委等七部委认定为国家农村产业融合发展示范园。几年来，示范园积极探索现代农业融合发展新路径，先后入驻状元红酒业等16家企业，初步打造成为了豫南一流的产业生态化、销售电商化、服务多元化的产业融合发展示范平台，探索创新现代农业产业三二一融合发展新模式。",
    },



    right_img:[
      {name:"农特产品电商交易中心",img:require("../assets/img/shancaixianqing/xq1/1.jpg")},
      {name:"创新创业中心",img:require("../assets/img/shancaixianqing/xq1/2.jpg")},
      {name:"中小企业孵化中心",img:require("../assets/img/shancaixianqing/xq1/3.jpg")},
      {name:"农产品质量检测中心",img:require("../assets/img/shancaixianqing/xq1/4.jpg")},
      {name:"冷链仓储物流中心",img:require("../assets/img/shancaixianqing/xq1/5.jpg")},
      {name:"电商培训学校",img:require("../assets/img/shancaixianqing/xq1/6.jpg")}
    ],
     options: {
      // src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/scxc.mp4", //视频源
      src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/zyhyq.mp4", //视频源
      type: "video/mp4", //视频类型
       poster: require("@/assets/img/shancaixianqing/xq1/left2.jpg"),
    },
  });
  onMounted(() => {

    // setTimeout(()=>{
    //   muteVideo()
    // },5000)


  });
  onUnmounted(() => {
    // 清理资源
  });
  onBeforeUnmount(() => {
    // clearInterval(timer.value);
  });
  function muteVideo(){
    if (videoPlayer.value) {
        // 获取视频元素
        const video = videoPlayer.value.$el.querySelector('video');
        console.log(video)
        if (video) {
          // 切换静音状态
          video.muted = !video.muted;
          console.log("开声音")
          console.log( video.muted )
        }
      }
  }
  function removeActive(num){
    state.curIndex[num]= false
  }
  function changeActive(num){
    console.log(num)
   state.curIndex[num]=true
   console.log(state.curIndex)
  }
  // 返回上一页
  function clickReturn() {
    router.go(-1);
    console.log("上一页")
  }




</script >

<style lang="less" scoped>

#video1 .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}
a{display: block;width: 100%;height: 100%;}
.contents {
  width: 100%;
  height: 100%;
  width: 100%;
  height: 100%;
  background: url("@{url}/img/xqbj1.png") no-repeat top center;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  .xia_content {
    width: 100%;
    height: calc(100% - 180px);
    // border: #fff 1px solid;
    margin-top: 180px;
    display: flex;
    padding-bottom: 40px;
    box-sizing: border-box;
    position: relative;
    z-index: 2;
    .first1 {
      width: 1506px;
      height: 100%;
      display: flex;
      flex-direction: column;
      margin: 0 60px;
      .first1_top {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        background: url("../assets/img/shancaixianqing/xq/k1.png") no-repeat;
        box-sizing: border-box;
        background-size: 100% 100%!important;
        .content_bt_qy{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          //  border: 1px solid #f00;
          .leftImg{
            width: 90%;
            display: flex;
          }
          .first1_top_down_img{
            height: 400px;
            margin: 20px 20px 0;

          }
          .first1_top_down_jian_jie{
            width: 100%;
            //height:580px;
            font-size: 40px;
            text-align: left;
            padding: 50px 100px;
            box-sizing: border-box;
            color: rgba(255,255,255,.7);
            line-height: 100px;
            //text-indent: 2em;
            position: relative;
            cursor: pointer;
          }
        }
      }

    }

    .first3 {
      flex: 1;
      height: calc(100% - 100px);
      background: url("../assets/img/shancaixianqing/xq/spk@2x.png") no-repeat;
      background-size: 100% 100%!important;
      margin-top: 100px;
      padding: 30px;
      box-sizing: border-box;
      overflow: hidden;
      .first3Box{
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        .videoBox{
          width: 3436px;
          // height: 1339px;
          height: 1450px;
          position: absolute;
          top:-160px;
          left: -200px;
          border: 1px solid;
          .shiptz {
          width: 100%;
          height: 100%;
          position: relative;
          // top: 322px;
          overflow: hidden;
          .jingyin{
            position: absolute;
            top: 200px;
            left: 300px;
            z-index: 999;
            font-size: 40px;
          }
          }
        }
      }
      
    }
    

    .first4 {
      width: 1533px;
      height: 100%;
      background: url("../assets/img/shancaixianqing/xq/k4.png") no-repeat;
      background-size: 100% 100%!important;
      margin: 0 30px;
      display: flex;
      flex-direction: column;
      .first4_box2{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-bottom: 40px;
        .fontBox{
          font-size: 36px;
          color:rgba(255,255,255,.8);
          text-align: left;
          line-height: 56px;
          //text-indent: 2em;
          padding: 50px 80px;
        }
        .rightList{
          width: 100%;
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          .rightListItem{
            width: 50%;
            h5{
              font-size: 34px;
              color:rgba(255,255,255,.8);
              margin-top: 20px;
              font-weight: normal;
            }
            img{
              width: 577px;
              height: 265px;
            }
          }
        }
      }
    }

  }

  // 标题
  .title{
    width: 100%;
    height: 60px;
    padding-left: 50px;
    box-sizing: border-box;
    line-height: 60px;
    color: #fff;
    background: url("../assets/img/shancaixianqing/xq/bt1.png") no-repeat;
    display: flex;
    span{display: block;}
     .txt1 {
        font-size: 30px;
        background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-style: italic;
        font-weight: bold;
        padding: 0 10px;
      }
      .txt2 {
        color: #0287ba;
        margin-left: 20px;
        font-size: 22px;
        font-family: Arial, Helvetica, sans-serif;
      }
  }
  //顶部标题
  .fontStyle{
    font-size: 30px;
    text-align: left;
    padding: 20px 30px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 50px;
    text-indent: 2em;
  }
}
</style>
